import React, { createContext, useContext, useState, useEffect } from "react";
import "./ErrorContext.css"; // puedes crear estilos aquí o usar inline

// 1️⃣ Contexto para mostrar errores
const ErrorContext = createContext();

// 2️⃣ Handler global que puede usarse desde api.js
let showErrorExternally = null;

export function ErrorProvider({ children }) {
  const [error, setError] = useState(null);

  useEffect(() => {
    showErrorExternally = (msg) => setError(msg);
  }, []);

  const hideError = () => setError(null);

  return (
    <ErrorContext.Provider value={{ showError: setError }}>
      {children}
      {error && (
        <div className="error-modal-backdrop">
          <div className="error-modal">
            <h4>Error</h4>
            <p>{error}</p>
            <button onClick={hideError} className="btn btn-danger mt-3">
              Cerrar
            </button>
          </div>
        </div>
      )}
    </ErrorContext.Provider>
  );
}

// 3️⃣ Hook para componentes React
export function useError() {
  return useContext(ErrorContext);
}

// 4️⃣ Función que se puede llamar desde fuera (ej. api.js)
export function triggerGlobalError(message, code) {
  if (typeof showErrorExternally === "function") {
    const fullMessage = code ? `Error ${code}: ${message}` : message;
    showErrorExternally(fullMessage);
  }
}

